import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import 'regenerator-runtime/runtime'
import { logout } from '../redux/actions/AuthActions'

const Routes = () => {
  const router = useRouter()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(logout())
    router.push('/')
  }, [router, dispatch])

  return null
}

export default Routes
